import type { ReactNode } from "react";

interface SectionProps {
  title: string;
  children: ReactNode;
}

export function Section({ title, children }: SectionProps) {
  return (
    <section>
      <h2
        className="mb-3"
        style={{
          fontSize: "10px",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.16em",
          color: "var(--color-stone)",
        }}
      >
        {title}
      </h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
